import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import productGroupQuery from '@/api/gql/product/query/product-group.gql'
import quickViewQuery from '@/api/gql/product/query/product-group-for-quick-view.gql'
import productDetailsQuery from '@/api/gql/product/query/product-details.gql'

const ProductDataService = {
  async fetch(variables, query = productGroupQuery) {
    const [error, result] = await to(
      client.query({
        query,
        variables,
      })
    )
    if (error) Vue.rollbar.error(error.message, error)
    return result
  },

  fetchQuickView(variables) {
    return this.fetch(variables, quickViewQuery)
  },

  fetchProductDetails(variables) {
    return this.fetch(variables, productDetailsQuery)
  },
}

export default ProductDataService
